import React from "react";

import { string, arrayOf, shape } from "prop-types";
import { Link } from "@quintype/components";

import "./StoryAuthors.m.css";
import { handleAuthorInteraction } from "../../../ga-utils";

const StoryAuthors = ({ storyAuthor, customStyleName, story, config, pageType }) => {
  return (
    <div styleName={customStyleName} className="authors">
      {storyAuthor?.map((author, index) => {
        const isLastIndex = index < storyAuthor.length - 1;
        const authorUrl = `/author/${author?.slug}`;
        return (
          <Link
            styleName="link"
            href={authorUrl}
            key={`${author?.slug}-${index}`}
            disableAjaxLinks={true}
            onTouchStart={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
            onMouseDown={() => handleAuthorInteraction(author, authorUrl, pageType, config, story)}
          >
            {`${author?.name}${isLastIndex ? ", " : ""}`}
          </Link>
        );
      })}
    </div>
  );
};

StoryAuthors.defaultProps = {
  storyAuthor: [],
  customStyleName: "",
};

StoryAuthors.propTypes = {
  storyAuthor: arrayOf(
    shape({
      slug: string,
    })
  ).isRequired,
  customStyleName: string.isRequired,
};

export default StoryAuthors;
